import React from "react";
import heic2any from "heic2any";
import store from "../../assets/store";

// eslint-disable-next-line import/no-anonymous-default-export
export default function ({ state }) {
  const {
    setUploadCompleted,
    setCaptures,
    captures,
    currentView,
    setError,
    hasToken,
    inputElement,
    setLoading,
  } = state;

  const imgFilehandler = async (event) => {
    const vehicleId = +store().get("vehicle");
    const inspected = +store().get("inspected");
    setLoading(true);
    const file = event.target.files[0];

    if (!file) return;

    let blob = new Blob([file], { type: file.type });

    if (file.type === "image/heic") {
      blob = await heic2any({
        blob,
        toType: "image/jpeg",
        quality: 0.5,
      });
    }

    if (!["image/jpeg", "image/png", "image/heic"].includes(file.type)) {
      alert("Invalid file type. Please select a JPEG, PNG or HEIC image.");
      return;
    }

    if ((hasToken || +inspected) && vehicleId) {
      try {
        setUploadCompleted(true);

        toDataURL(URL.createObjectURL(blob), async function (base64) {
          const compressed64 = await reduceImageQuality(base64, 0.2);
          const newCapture = { url: compressed64, view: currentView };
          const isPresent = captures?.findIndex(
            (item) => item.view === newCapture.view
          );
          if (isPresent !== -1) {
            const updated = [...captures];
            updated[isPresent] = { ...updated[isPresent], url: newCapture.url };
            setCaptures(updated);
          } else {
            setCaptures([...captures, newCapture]);
          }

          setUploadCompleted(false);
        });

        localStorage.removeItem("inspected");
      } catch (error) {
        console.log({ error });
        if (error.response?.status === 400) {
          setError("Invalid url");
        }
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <input
      accept="image/heic,image/*"
      id="fileid"
      type="file"
      ref={inputElement}
      capture="environment"
      onChange={imgFilehandler}
      hidden
    />
  );
}

function toDataURL(url, callback) {
  const xhr = new XMLHttpRequest();
  xhr.onload = function () {
    const reader = new FileReader();
    reader.onloadend = function () {
      callback(reader.result);
    };
    reader.readAsDataURL(xhr.response);
  };
  xhr.open("GET", url);
  xhr.responseType = "blob";
  xhr.send();
}

function reduceImageQuality(base64, quality = 0.5) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = base64;

    img.onload = function () {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;

      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);

      canvas.toBlob(
        function (blob) {
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = function () {
            resolve(reader.result);
          };
        },
        "image/jpeg",
        quality
      );
    };

    img.onerror = function (error) {
      reject(error);
    };
  });
}
